module.exports = __webpack_public_path__ + "static/img/activitydesc.b8a9940d.svg";